<div class="dialog-container">
  <ng-container [ngSwitch]="orderStep">
    <!--未收到短信验证码？-->
    <ng-container *ngSwitchCase="'unrecived-code'">
      <div class="main-container" style="height: 434px">
        <div class="logo-row">
          <img src="assets/temp5/send-voice.svg" alt="" />
        </div>
        <div class="bold-txt">{{ 'sms_ver_code00' | translate }}</div>
        <div class="txt-loop">
          <span *ngFor="let item of contantList">{{ item }}</span>
        </div>
        <div class="btn-group">
          <customize-button width="100%" type="default" (onClick)="close()">
            {{ 'sms_ver_code07' | translate }}
          </customize-button>
          <customize-button width="100%" type="primary-linear" (onClick)="sendVoice()">
            {{ 'sms_ver_code08' | translate }}
          </customize-button>
        </div>
      </div>
    </ng-container>
    <!--注册提示-->
    <ng-container *ngSwitchCase="'area-notice'">
      <div class="main-container">
        <div class="logo-row">
          <!-- <img src="assets/temp5/red-error.svg" alt=""> -->
          <!-- TODO:這邊改svg改成iconfont樣式可能要改 但目前功能移除看不到 -->
          <i class="icon-warning3"></i>
        </div>
        <div class="bold-txt">{{ 'reg_tip00' | translate }}</div>
        <div class="txt-center">{{ 'afghanistan' | translate }}{{ 'reg_tip02' | translate }}</div>
        <div class="btn-group">
          <customize-button width="157px" type="primary-linear" (onClick)="close()">
            {{ 'confirm_button' | translate }}
          </customize-button>
        </div>
      </div>
    </ng-container>
  </ng-container>
</div>
